import React from 'react';
import { insidePages } from '../data/content';
interface PageFrameProps {
  src: string;
  caption: string;
  className?: string;
  isPrimary?: boolean;
}
function PageFrame({
  src,
  caption,
  className = '',
  isPrimary = false
}: PageFrameProps) {
  const isPdf = src.toLowerCase().endsWith('.pdf');
  return <figure className={`relative ${className}`} data-id="element-15" data-mp="298opa73utr6s">
      <div className={`overflow-hidden rounded-[10px] border border-brand-charcoal/10 bg-white ${isPrimary ? 'shadow-[0_18px_40px_-24px_rgba(41,56,58,0.28)]' : 'shadow-[0_12px_28px_-20px_rgba(41,56,58,0.24)]'}`} data-id="element-16" data-mp="299ztu954j2yy">
        <div className="relative aspect-[3/4] w-full bg-white" data-id="element-17" data-mp="2x4awfww80l1t">
          {isPdf ? <iframe src={`${src}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`} title={`${caption} — page from The Baby Sleep Bible`} loading="lazy" scrolling="no" className="pointer-events-none absolute inset-0 h-full w-full border-0" data-id="element-18" data-mp="2s5psbmdulh83" /> : <img src={src} alt={`${caption} — page from The Baby Sleep Bible`} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover object-top" data-id="element-19" data-mp="1mofjitk9ma0u" />}
        </div>
      </div>
      <figcaption className="mt-3 font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/45" data-id="element-20" data-mp="1htjgyzhek49h">
        {caption}
      </figcaption>
    </figure>;
}
export function InsidePages() {
  const [primary, ...rest] = insidePages;
  return <div className="flex items-start justify-center" data-id="element-21" data-mp="uvyda6nmmsha">
      <PageFrame src={primary.src} caption={primary.caption} isPrimary className="z-30 w-[66%] max-w-[400px] sm:w-[52%]" data-id="element-22" data-mp="ux9djwhv5i3n" />
      {rest[0] && <PageFrame src={rest[0].src} caption={rest[0].caption} className="z-20 -ml-[8%] mt-10 w-[42%] max-w-[300px] sm:mt-14 sm:w-[38%]" data-id="element-23" data-mp="2p9z9ejrsl1do" />}
      {rest[1] && <PageFrame src={rest[1].src} caption={rest[1].caption} className="z-10 -ml-[6%] mt-20 hidden w-[32%] max-w-[250px] sm:mt-24 sm:block" data-id="element-24" data-mp="60916lbqorrd" />}
    </div>;
}